import { render } from "./tw-carousel.vue?vue&type=template&id=32648eba"
import script from "./tw-carousel.vue?vue&type=script&lang=js"
export * from "./tw-carousel.vue?vue&type=script&lang=js"
script.render = render

export default script